import { TranslationKey } from '../../../../types/translation/TranslationKey';
import React, { useContext, useMemo } from 'react';
import { useState } from 'react';
import { t } from '../../../../types/translation/Translator';
import { useNavigate } from 'react-router-dom';
import { ProductMasterDataContext } from '../../../../context/ProductMasterDataContext';
import ImportProductMasterDataModal from './Modals/ImportProductMasterDataModal';
import DeleteProductMasterDataModal from './Modals/DeleteProductMasterDataModal';
import { CompanyContext } from '../../../../context/CompanyContext';
import { CompanyRoleAssignmentContext } from '../../../../context/CompanyRoleAssignmentContext';
import SearchBarWithFilter from '../../../../VentoryUI/components/common/SearchBarWithFilter';
import { ProductMasterDataFilter } from '../../../../VentoryUI/components/filters/ProductMasterDataFilter';
import Table from '../../../components/Table';
import { FileContext } from '../../../../context/FileContext';
import { Routing } from '../../../../util/routes.util';
import { CustomFieldContext } from '../../../../context/CustomFieldContext';
import { DeleteIconButton, SettingsIconButton } from '../../../icons';
import { CreateButton, ExportIconButton, ImportIconButton } from '../../../components/Button';
import { TagRelationContext } from '../../../../context/TagRelationContext';
import { productMasterDataTableHeaders } from '../../../components/Table/ProductMasterData/ProductMasterDataTable';
import { ProductMasterDataExportModal } from './Modals/ProductMasterDataExportModal';
import { UserContext } from '../../../../context/UserContext';
import { TableSettingsContext } from '../../../../context/TableSettingsContext';
import { EntityType } from '../../../../types/comment';

export default function ProductMasterDataOverviewPane() {
  const navigate = useNavigate();

  const { currentCompany, companies } = useContext(CompanyContext);
  const { productMasterData, productMasterDataLoading } = useContext(ProductMasterDataContext);
  const { isAdmin } = useContext(CompanyRoleAssignmentContext);
  const { files } = useContext(FileContext);
  const { customFields } = useContext(CustomFieldContext);
  const { tagRelations, tagRelationsLoading } = useContext(TagRelationContext);
  const { getTableSettings } = useContext(TableSettingsContext);
  const { locale } = useContext(UserContext);
  const productMasterDataTableSettings = getTableSettings(EntityType.pmd, currentCompany.id);

  const [items, setItems] = useState([...productMasterData.values()]);

  const [openImportModal, setOpenImportModal] = useState<boolean>(false);
  const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false);
  const [openExportModal, setOpenExportModal] = useState<boolean>(false);
  const [selected, setSelected] = useState<Set<string>>(new Set());

  const allItems = useMemo(() => {
    return [...productMasterData.values()];
  }, [productMasterData]);

  const hasSelected = selected.size;

  const filter = new ProductMasterDataFilter(
    customFields,
    tagRelations,
    currentCompany,
    productMasterDataTableSettings,
  );

  return (
    <>
      {openImportModal && <ImportProductMasterDataModal open={openImportModal} setOpen={setOpenImportModal} />}
      {openDeleteModal && (
        <DeleteProductMasterDataModal open={openDeleteModal} setOpen={setOpenDeleteModal} idsToDelete={selected} />
      )}
      {openExportModal && <ProductMasterDataExportModal open={openExportModal} setOpen={setOpenExportModal} />}

      <div className='content-x content-y-screen flex flex-grow flex-col gap-4'>
        <div className='flex justify-between gap-2'>
          <SearchBarWithFilter
            loading={productMasterDataLoading || tagRelationsLoading}
            placeholder={t(TranslationKey.filterProductReferenceData).singular.label}
            items={allItems}
            setItems={setItems}
            filter={filter}
          />
          <div className='flex gap-2'>
            {hasSelected && isAdmin ? <DeleteIconButton onClick={() => setOpenDeleteModal(true)} /> : null}
            <ExportIconButton onClick={() => setOpenExportModal(true)} />
            {isAdmin ? <ImportIconButton onClick={() => setOpenImportModal(true)} /> : null}
            {isAdmin ? <CreateButton onClick={() => navigate(Routing.productMasterData.create())} /> : null}
            {isAdmin ? (
              <SettingsIconButton onClick={() => navigate(Routing.productMasterData.settings.overview())} />
            ) : null}
          </div>
        </div>

        <Table
          filter={filter}
          title={t(TranslationKey.referenceData).singular.label}
          loading={productMasterDataLoading}
          items={items}
          headers={productMasterDataTableHeaders(
            productMasterDataTableSettings,
            files,
            companies,
            currentCompany,
            locale,
          )}
          totalItemCount={allItems.length}
          onClick={item => navigate(Routing.productMasterData.update(item.id).info())}
          onSelected={items => (isAdmin ? setSelected(new Set(items)) : null)}
        />
      </div>
    </>
  );
}
